import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Sun, Plus } from "@phosphor-icons/react";

export default function Gratitude() {
  const [items, setItems] = useState(["", "", ""]);
  const [list, setList] = useState([]);

  const load = () => api.get("/gratitude").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    const filtered = items.map((i) => i.trim()).filter(Boolean);
    if (filtered.length === 0) return;
    try {
      await api.post("/gratitude", { items: filtered });
      setItems(["", "", ""]);
      toast.success("Three small lights, captured.");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-10">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-sage font-bold mb-2">Gratitude</p>
        <h1 className="font-serif text-4xl md:text-5xl font-medium">Three small lights today.</h1>
      </div>

      <div className="bg-white rounded-3xl border border-border p-6 md:p-8 soft-shadow space-y-3">
        {items.map((v, i) => (
          <div key={i} className="flex items-center gap-3">
            <Sun size={20} weight="duotone" className="text-clay shrink-0" />
            <input value={v} onChange={(e) => { const next = [...items]; next[i] = e.target.value; setItems(next); }}
                   data-testid={`gratitude-input-${i}`}
                   placeholder={`Something good (${i + 1})`}
                   className="flex-1 px-4 py-2.5 rounded-full border border-border bg-sand focus:outline-none focus:ring-2 focus:ring-sage" />
          </div>
        ))}
        <div className="flex justify-end pt-2">
          <button onClick={save} data-testid="gratitude-save"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-moss text-white hover:bg-mossDark">
            <Plus size={16}/> Save gratitude
          </button>
        </div>
      </div>

      <div className="space-y-3">
        {list.map((g) => (
          <div key={g.id} className="bg-white rounded-2xl border border-border p-5">
            <p className="text-xs tracking-[0.2em] uppercase text-sage font-bold mb-2">
              {new Date(g.created_at).toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" })}
            </p>
            <ul className="space-y-1.5">
              {g.items.map((it, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-clay mt-2"/>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
